(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.NSPoeCalculatorRender = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function safeUrl(value) {
    var url = String(value || '').trim();
    return /^(?:https?:\/\/|\/)/i.test(url) ? escapeHtml(url) : '#';
  }

  function renderProductLink(url, content, className) {
    return '<a class="' + className + '" href="' + safeUrl(url) + '" target="_blank" rel="noopener noreferrer">' + content + '</a>';
  }

  function renderProductCard(product, options) {
    var item = product || {};
    var rank = options && options.rank || '';
    var status = item.verificationStatus === 'conditional' ? 'Potential match - confirm' : 'Verified match';
    var image = item.image
      ? renderProductLink(item.url, '<img src="' + safeUrl(item.image) + '" alt="" loading="lazy" width="480" height="480">', 'ns-poe-card__image')
      : '<div class="ns-poe-card__image ns-poe-card__image--empty" aria-hidden="true"></div>';
    var title = renderProductLink(item.url, escapeHtml(item.title || 'View switch'), 'ns-poe-card__title');
    var cta = item.available
      ? renderProductLink(item.url, 'View product', 'ns-poe-button ns-poe-button--secondary')
      : '<a class="ns-poe-button ns-poe-button--secondary" href="#chatty-chat" data-ns-poe-chatty>了解是否有货？</a>';
    var specs = [];
    if (item.poePorts != null) specs.push(escapeHtml(item.poePorts) + ' PoE ports');
    if (item.totalBudgetW != null) specs.push(escapeHtml(item.totalBudgetW) + 'W PoE budget');
    if (item.maxPerPortW != null) specs.push(escapeHtml(item.maxPerPortW) + 'W max per port (PSE)');
    if (item.management) specs.push(escapeHtml(item.management));
    if (item.environment) specs.push(escapeHtml(item.environment));
    if (Array.isArray(item.uplinks) && item.uplinks.length) specs.push(escapeHtml(item.uplinks.join(', ')) + ' uplink');
    return '<article class="ns-poe-card" data-product-id="' + escapeHtml(item.id) + '" data-rank="' + escapeHtml(rank) + '">' +
      image + '<div class="ns-poe-card__body"><p class="ns-poe-eyebrow">' + escapeHtml(status) + (item.vendor ? ' · ' + escapeHtml(item.vendor) : '') + '</p>' +
      '<h3>' + title + '</h3><p class="ns-poe-card__specs">' + specs.join(' &middot; ') + '</p>' +
      '<p class="ns-poe-card__reason">' + escapeHtml(item.fitReason) + '</p>' +
      (item.price ? '<p class="ns-poe-card__price">' + escapeHtml(item.price) + '</p>' : '') +
      '<p class="ns-poe-card__availability">' + (item.available ? 'Available to order' : 'Availability needs confirmation') + '</p>' +
      cta + '</div></article>';
  }

  function renderRecommendations(products) {
    var result = Array.isArray(products) ? { verified: products.slice(0, 6), conditional: [] } : (products || {});
    var verified = Array.isArray(result.verified) ? result.verified.slice(0, 6) : [];
    var conditional = Array.isArray(result.conditional) ? result.conditional.slice(0, Math.max(0, 6 - verified.length)) : [];
    var list = verified.concat(conditional);
    var intro = verified.length
      ? '<p class="ns-poe-help">Verified matches pass the published power, powered-port and selected project gates. Conditional links are clearly labelled and still require datasheet confirmation.</p>'
      : conditional.length
        ? '<p class="ns-poe-help">These potential matches pass the published base power and port gates, but one or more selected or high-power port-count specifications need confirmation.</p>'
        : '';
    return '<section class="ns-poe-result" data-ns-poe-result-region="recommendations"><p class="ns-poe-step">03 · Product links</p>' +
      '<h2>Recommended switches for your project</h2>' +
      (list.length
        ? intro + '<div class="ns-poe-card-grid">' +
          list.map(function (item, index) { return renderProductCard(item, { rank: index + 1 }); }).join('') + '</div>'
        : '<p class="ns-poe-empty">' + (result.manual
          ? 'The maximum PD input exceeds the standard automatic per-port gate. Confirm proprietary power or local power with an engineer.'
          : 'No catalog product passed the complete hard requirements automatically. Your calculated requirements are still shown above. Use the optional form below for a manual or multi-switch match.') + '</p>') +
      '</section>';
  }

  return Object.freeze({ escapeHtml: escapeHtml, renderProductCard: renderProductCard, renderRecommendations: renderRecommendations });
});
